import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import FlowResourceDisplay from '../FlowResourceDisplay';
import { FlowModel } from '../../../types/flow.types';
import { EntityDetailCardSection } from '../EntityDetailCard';

interface Props {
  flowModel: FlowModel;
  isLoading?: boolean;
  isSuccess?: boolean;
}

const FlowHeaderSourceSection: React.FC<Props> = ({ flowModel, isLoading }) => (
  <EntityDetailCardSection data-cy="flow-header-source-section">
    <Typography variant="overline" fontWeight={900}>
      SOURCE
    </Typography>
    {isLoading ? (
      <Skeleton variant="text" width="100%" />
    ) : (
      <FlowResourceDisplay flow={flowModel} direction="source" />
    )}
  </EntityDetailCardSection>
);

export default FlowHeaderSourceSection;
